module.exports = __webpack_public_path__ + "img/NADA01_iPad.9a8bc1fb.jpg";